import { QuickApiServiceBase, QuickConsoleLogger } from 'hooks/services';
import { appApiProvider } from './axiosApiProvider';
import { ChatMessage, IFormApplicationDTO } from 'shared/interfaces/formApplication';

class ChatMessagesService extends QuickApiServiceBase {
    constructor() {
        super(new QuickConsoleLogger('ChatMessagesService'), appApiProvider, 'chat', 'ChatMessages');
    }

    public async add(applicationId: string, message: Omit<ChatMessage, 'id'>): Promise<ChatMessage[]> {
        // id is generated on the server side
        const response: IFormApplicationDTO = await this.postOrThrow({ applicationId, ...message }, { url: '/addChatMessage' });
        // console.log('ChatMessagesService.add response:', response);
        const newChatMessagesArray = response.chatMessages || [];
        return newChatMessagesArray as ChatMessage[];
    }

    // אפשר להוסיף כאן גם getAll וכו' בהמשך
}

export const chatMessagesService = new ChatMessagesService();
